
function toConfigName(name) {
  return name.toLowerCase().replace(/[^a-zA-Z0-9 ]/g, '').replace(/ +/g, '_');
}

export { toConfigName };